/**
 * CustomFieldTypeService
 * Shared, cross-cutting custom-field-type catalogue. Read endpoints are public (no auth);
 * admin mutations require Admin role with System.Admin permission server-side.
 * Route: api/custom-field-types
 */
import { CrudService } from '../base/CrudService';
export class CustomFieldTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CustomFieldTypeService.DEFAULT_SERVICE_PATH,
            basePath: CustomFieldTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Returns the full custom-field-type catalogue. */
    async list() {
        const res = await this.http.get(this.buildUrl());
        return res?.data ?? [];
    }
}
CustomFieldTypeService.DEFAULT_SERVICE_PATH = 'system';
CustomFieldTypeService.BASE_PATH = 'api/custom-field-types';
//# sourceMappingURL=CustomFieldTypeService.js.map